var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-editor"},[_c('document-editor',{key:_vm.projectId + _vm.documentId,attrs:{"document-id":_vm.documentId,"project-id":_vm.projectId,"is-modal":_vm.isModal},on:{"close":function($event){return _vm.$emit('close')},"update":function($event){return _vm.$emit('update')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }